import type { Offer, Order } from '../../types/checkout';

import { cleengFormatPrice, formatPrice } from './formatting';

export const getOfferPrice = (offer: Offer) => formatPrice(offer.customerPriceInclTax, offer.customerCurrency, offer.customerCountry);

export const getAvailableOfferPrice = (customerPriceInclTax: number, customerCurrency: string, customerCountry: string) =>
  formatPrice(customerPriceInclTax, customerCurrency, customerCountry);

export const isSVODOffer = (offer: Offer | Order) => offer.offerId?.[0] === 'S';

export const getCleengOfferPrice = (offer: any) => {
  return cleengFormatPrice(offer.price.amount, offer.price.currency);
};
